class ComponentCardQuestion {
  constructor() {
    this._init();
  }

  _init() {
    const questions = document.querySelectorAll('.card-question');

    questions.forEach(function (question) {
      question.addEventListener(
        'click',
        function () {
          question.classList.toggle(
            'card-question--open'
          );
        },
        false
      );
    });
  }
}

export const componentCardQuestion = new ComponentCardQuestion();
